import { Location, useLocation } from "react-router-dom"
import routes from "routes"

const getPathsWithNoDivider = (location: Location) => {
  // Represents the pathnames on which divider should *NOT* appear
  const pathnames = [
    routes.learning,
    routes.notifications,
    routes.aiTools.home,
    routes.home,
    routes.settings,
    routes.privacy,
    routes.accountDetails,
    routes.notificationSettings,
    routes.orders,
    routes.discussions,
  ]

  return pathnames.includes(location.pathname)
}

export const useExcludeDivider = () => {
  const location = useLocation()
  return getPathsWithNoDivider(location)
}
